import React from 'react';
import { useHistory } from 'react-router';
import { Operation, ProviderType } from 'shared/types/flowstep';
import { FlowstepCategory, RangeType } from 'shared/utils/flowstep';
import { NavItem } from 'src/components/base/ListNav';
import { runCancelableAction } from 'src/services/utils';
import { useStores } from 'src/v2/hooks/useStores';
import { getRoute } from 'src/v2/services/flowsteps/routing';
import { useStyles } from './HubspotHome.styles';

export const HubspotHome = () => {
  const styles = useStyles();
  const history = useHistory();

  const { officeStore } = useStores();

  return (
    <div className={styles.hubspotHome}>
      <NavItem
        classes={{ root: styles.navItem }}
        title='Import Data'
        secondaryText='Import data from a Hubspot objects or CSV file'
        licensing={undefined}
        teaching={undefined}
        history={undefined}
        menuItems={[
          {
            key: 'Objects',
            text: 'From Objects and Fields',
            onClick: () => {
              history.push(getRoute(null, Operation.PULL, ProviderType.HS));
            }
          },
          {
            key: 'Lists',
            text: 'From a List',
            onClick: () => {
              history.push(getRoute(null, Operation.PULL, ProviderType.HubspotList));
            }
          },
        ]}
      />
      <NavItem
        classes={{ root: styles.navItem }}
        title='Refresh Data'
        secondaryText='Refresh a previously connected Hubspot Flowstep'
        licensing={undefined}
        teaching={undefined}
        history={undefined}
        menuItems={[
          {
            key: 'active',
            text: 'Active Worksheet',
            onClick: async () => {
              await runCancelableAction(async (cancelToken: any) => {
                await officeStore.refreshCurrentSheet(FlowstepCategory.Pull, cancelToken);
              })
            }
          },
          {
            key: 'all',
            text: 'All Worksheets',
            onClick: async () => {
              await runCancelableAction(async (cancelToken: any) => {
                await officeStore.refreshAllSheets(FlowstepCategory.Pull, cancelToken);
              });
            }
          }
        ]}
      />
      <NavItem
        classes={{ root: styles.navItem }}
        title='Create/Modify'
        secondaryText='Create or modify records in Hubspot using data from Excel rows'
        licensing={undefined}
        teaching={undefined}
        history={undefined}
        menuItems={[
          {
            key: 'update_selected',
            text: 'Update Selected',
            onClick: () => {
              history.push(getRoute(null, Operation.UPDATE, ProviderType.HS, { rangeToApply: RangeType.Selected }));
            }
          },
          {
            key: 'update_all',
            text: 'Update All',
            onClick: () => {
              history.push(getRoute(null, Operation.UPDATE, ProviderType.HS, { rangeToApply: RangeType.All }));
            }
          },
          null,
          {
            key: 'insert_selected',
            text: 'Insert Selected',
            onClick: () => {
              history.push(getRoute(null, Operation.INSERT, ProviderType.HS, { rangeToApply: RangeType.Selected }));
            },
          },
          {
            key: 'insert_all',
            text: 'Insert All',
            onClick: () => {
              history.push(getRoute(null, Operation.INSERT, ProviderType.HS, { rangeToApply: RangeType.All }));
            },
          },

        ]}
      />
      <NavItem
        classes={{ root: styles.navItem }}
        title='Delete'
        secondaryText='Delete records in Hubspot using ID values from Excel rows'
        licensing={undefined}
        teaching={undefined}
        history={undefined}
        menuItems={[
          {
            key: 'delete_selected',
            text: 'Delete Selected',
            onClick: () => {
              history.push(getRoute(null, Operation.DELETE, ProviderType.HS, { rangeToApply: RangeType.Selected }));
            },
          },
          {
            key: 'delete_all',
            text: 'Delete All',
            onClick: () => {
              history.push(getRoute(null, Operation.DELETE, ProviderType.HS, { rangeToApply: RangeType.All }));
            },
          }
        ]}
      />
    </div>
  );
}
